<mat-expansion-panel class="shadow-none border-gray-300 border-solid border mt-3">
    <mat-expansion-panel-header [title]="">{{"return_request_details"|translate}}</mat-expansion-panel-header>

    <div class="card-divider my-3"></div>

    <div>{{("return_request_note" | translate) + ((returnData?.request?.note) || "-")}}</div>

    <div *ngIf="returnData?.request?.timestamp" class="text-sm">{{"request_date"|translate }} {{ returnData?.request?.timestamp |date:'medium' }}</div>


    <div class="card-divider mt-3"></div>


    <div class="card-table">
        <div class="table-responsive-sm">
            <table>
                <thead>
                    <tr>
                        <th>{{"product"|translate}}</th>
                        <th>{{"reason"|translate}}</th>
                        <!-- <th>{{"note"|translate}}</th> -->
                        <th>{{"status"|translate}}</th>
                    </tr>
                </thead>
                <tbody class="card-table__body card-table__body--merge-rows">
                    <tr *ngFor="let item of returnData?.request?.items; let index = index;">
                        <td>{{ translateHelper.localize(item?.name)}} × {{ item.amount }}</td>
                        <td>{{ item.reason }}</td>
                        <!-- <td>{{ item.note }}</td> -->
                        <td>
                            <div class="flex flex-row flex-wrap">
                                <div class="capitalize">{{(returnData?.response?.items[index]?.status || "-")}}</div>
                                <!-- <div *ngIf="returnData?.response?.items[index]?.note">{{("note"|translate) + ": "}}{{returnData?.response?.items[index]?.note}}</div> -->
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>
        </div>
    </div>


</mat-expansion-panel>



